import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const assignTicket = async (username: string, ticketUniqueCode: string) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/tickets/assign`, { ticketUniqueCode, username  }, {
            withCredentials: true
        });
    } catch (error) {
        throw error;
    }
};